"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormErrorMessage = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const FormErrorMessage_1 = require("@reactionable/core/lib/form/FormErrorMessage");
const Feedback_1 = tslib_1.__importDefault(require("react-bootstrap/Feedback"));
function FormErrorMessage(_a) {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return (jsx_runtime_1.jsx(FormErrorMessage_1.FormErrorMessage, Object.assign({}, props, { children: children !== null && children !== void 0 ? children : ((errorMessage) => jsx_runtime_1.jsx(Feedback_1.default, Object.assign({ type: "invalid" }, { children: errorMessage }), void 0)) }), void 0));
}
exports.FormErrorMessage = FormErrorMessage;
//# sourceMappingURL=FormErrorMessage.js.map